<template>
  <header class="header">
    <div class="header-bgm" :class="getBgmClass" @click="switchBgmStatus">
      <div class="header-bgm__close" v-show="!$bus.bgmStatus"></div>
    </div>
    <h1 class="header-title">
      <div class="text">{{ $bus.transify['LUCKY_TITLE'] }}</div>
      <i @click="showRule" class="rule"></i>
      <i @click="showHistory" class="history"></i>
    </h1>
    <div class="header-right">
      <i class="diamond"></i>
      <div class="user-info">
        <span class="gems number-normal">{{ getGem }}</span>
        <span class="user-id font-normal">ID: {{ $bus.uid }}</span>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  computed: {
    getBgmClass () {
      return this.$bus.bgmStatus ? 'header-bgm__open' : ''
    },
    getGem: {
      get () {
        return this.$bus.gems
      },
      set (val) {
        this.$bus.gems = val
      }
    }
  },
  methods: {
    switchBgmStatus () {
      if (this.$bus.animating) {
        return
      }
      this.$bus.bgmStatus = !this.$bus.bgmStatus
      this.$bus.addGA(`${this.$bus.bgmStatus ? 'open' : 'close'}-bgm`, 'click')
      if (this.$bus.bgmStatus) {
        localStorage.setItem(`${PROJECT_NAME}_${this.$bus.uid}_bgm`, 'y')
      } else {
        localStorage.setItem(`${PROJECT_NAME}_${this.$bus.uid}_bgm`, 'n')
      }
    },
    showHistory () {
      if (this.$bus.animating) {
        return
      }
      this.$api.history().then(res => {
        this.$bus.history.data = res.data.history.sort((a, b) => b.created - a.created)
        this.$bus.history.show = true
        this.$bus.addGA('history', 'show')
      })
    },
    showRule () {
      if (this.$bus.animating) {
        return
      }
      this.$bus.rule.show = true
      this.$bus.addGA('rule', 'show')
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: center;
  @include px2res(height, 72);
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  @include px2res(margin-top, -1);
  background-position-y: top;
}
.header-right {
  position: absolute;
  @include px2res(right, 16);
  @include px2res(top, 8);
  .diamond {
    position: absolute;
    @include px2res(left, -36);
    @include px2res(top, 3);
    @include px2res(width, 30);
    @include px2res(height, 27);
  }
  .gems {
    @include px2res(font-size, 36);
    @include px2res(height, 30);
    line-height: 1;
    color: #F1F1F1;
  }
  .user-info {
    @include flexcc;
    align-items: flex-start;
  }
  .user-id {
    @include px2res(font-size, 16);
    @include px2res(margin-top, 3);
    color: #F2F2F2;
  }
}

.header-title {
  display: flex;
  align-items: center;
  text-transform: uppercase;
  height: 100%;
  .text {
    font-weight: 500;
    @include px2res(padding, 0, 10);
    @include text-gradient(rgba(255,255,255,1) 30%, rgba(251,237,101,1) 70%);
    @include px2res(font-size, 48);
  }
  .rule,
  .history {
    @include px2res(width, 40);
    @include px2res(height, 40);
  }
  .history {
    @include px2res(margin-left, 10);
  }
}

.header-bgm {
  position: absolute;
  @include px2res(top, 16);
  @include px2res(left, 40);
  @include px2res(width, 37);
  @include px2res(height, 39);

  &.header-bgm__open {
    animation: rotating 10s linear infinite;
  }

  .header-bgm__close {
    position: absolute;
    @include px2res(top, 2);
    @include px2res(left, 6);
    @include px2res(width, 33);
    @include px2res(height, 31);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue